import { render, staticRenderFns } from "./inventoryReports.vue?vue&type=template&id=915677c6&scoped=true"
import script from "./inventoryReports.vue?vue&type=script&lang=js"
export * from "./inventoryReports.vue?vue&type=script&lang=js"
import style0 from "./inventoryReports.vue?vue&type=style&index=0&id=915677c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915677c6",
  null
  
)

export default component.exports